import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'
interface AvailableCreditTooltipProps {
  openLeft: boolean
}

const AvailableCreditTooltip: React.FC<AvailableCreditTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${availableCredit} is the amount you have left to spend on your virtual card.'
          }
          expressions={{
            availableCredit: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Available Credit'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default AvailableCreditTooltip
